import { useEffect, useState } from 'react';
import './DevloperLoginPage.css';
import api from '../Resume Components/Pages/Login and Sign UP/api.js';
import { useNavigate } from 'react-router-dom';

let DevloperLoginPage=(props)=>{
    let  navigate = useNavigate();
    let [email, setemail]= useState('');
    let [password, setpassword]= useState('');
    let [error, seterror]=useState('');
    let [msg, setmsg]=useState(false);
    useEffect(()=>{
        let login = localStorage.getItem("devlogin");
        if(login){ 
            navigate("../DevloperPanel"); 
        }
        let loginStatus = localStorage.getItem("loginStatusdev");
        if(loginStatus){
            seterror(loginStatus);
            props.Successandrerrorfun("", loginStatus);
            setTimeout(function(){
                localStorage.clear();  
                window.location.reload();
            }, 2000);
        }
        setTimeout(() => {
            setmsg("");
        }, 3000);
         
    },[msg]);
    let handelchange=(e, type)=>{
   switch(type){
    case "email":
        seterror("");
        setemail(e.target.value);
        if(e.target.value === ""){
            seterror("Email id left blank"); 
            props.Successandrerrorfun("", "Email id left blank");
        }
        break;
     case "pass": 
        seterror("");
        setpassword(e.target.value);
        if(e.target.value=== ""){
            seterror("Password left blank");
            props.Successandrerrorfun("", "Password left blank");

            
        }

   }
  }
    let devloperloginpagesubmitfunction=async(e)=>{
            e.preventDefault();
            let devlogformdata = new FormData();
            devlogformdata.append("email", email);
            devlogformdata.append("password", password);

            try {
                const resp = await api.post("/Devloperlogin.php", devlogformdata);
                if(resp.data[0].result === "Invalid Email-Id" || resp.data[0].result === "Invalid Password"){
                    seterror(resp.data[0].result);
                    props.Successandrerrorfun("", resp.data[0].result);

                    setTimeout(() => {
                        seterror("");
                    }, 3000);
                 
                }else{
                    setmsg(true);
                     if(resp.data[0].JWT === undefined){
                        seterror(resp.data[0].result);
                        props.Successandrerrorfun("", resp.data[0].result);

                        setTimeout(() => {
                             seterror("");
                        }, 3000);
                     }else{
                     props.Successandrerrorfun(resp.data[0].result , "");
                     setmsg(resp.data[0].result);  
                     setTimeout(function(){
                        setmsg(false); 
                       localStorage.setItem("devlogin", true);
                        localStorage.setItem("devtoken" , resp.data[0].JWT)
                        }, 3000);
                    }
                }
            } catch (error) {
                console.log(error);
                
            }
        
    }









    
    return(
        <div className='devloginmaincont'>
            <div className='devlogsubcont'>
                <h2 className='devlogheading'>Devloper Login</h2> 
                        {
                            error !== "" ?
                            <p style={{textAlign: 'center', color: "red"}}>{error}</p> :
                            <p style={{textAlign: 'center', color: "green"}}>{msg}</p>
                        }
                <form onSubmit={devloperloginpagesubmitfunction} className='emailpasscont'>
                    <div>
                        
                        <input value={email} onChange={(e)=>{handelchange(e, "email")}}  name='email' type='text' placeholder='Email-Id'/>
                        <input onChange={(e)=>{handelchange(e, "pass")}}  name='password'value={password} type='password' autoComplete='true' placeholder='Enter Password'/>
                    </div>
                    
                    <input className='submitbtn' type='submit' value="Submit"/>
                </form>
            </div>
        </div>  
    );
}
export default DevloperLoginPage;